import { FunctionComponent, ReactNode } from 'react'

import styled, { css } from 'styled-components'

import { desktopCSS, mobileCSS, tabletCSS } from '@measures/responsive'
import useClientViewportType from '@hooks/useClientViewportType'
import useIsInUltraModuleBundling from '@hooks/useIsInUltraModuleBundling'

interface RelatedItemsWrapperProps {
  children?: ReactNode
  accentColor?: string
  hasSportsPartner?: boolean
}

const StyledRelatedItemsWrapper = styled.div<
  Omit<RelatedItemsWrapperProps, 'children'>
>`
  ${({
    theme: {
      colors: { staticRed500 },
      spacing: { spacing8, spacing16, spacing24 },
      measures: { stretchWidthOnMobile },
    },
    accentColor,
    hasSportsPartner,
  }) => css`
    ${stretchWidthOnMobile()};
    ${desktopCSS(css`
      display: none;
    `)}

    display: grid;
    grid-row-gap: ${spacing16};

    ${mobileCSS(css`
      margin-right: 0;
    `)}

    ${tabletCSS(css`
      margin-left: -${spacing16};
      padding-left: ${spacing8};
    `)}

    border-left: solid ${spacing8} ${accentColor ?? staticRed500};

    margin-top: -${hasSportsPartner ? spacing16 : spacing24};
    padding-top: ${spacing24};
    padding-left: ${spacing8};
  `}
`

const RelatedItemsWrapper: FunctionComponent<RelatedItemsWrapperProps> = ({
  children,
  accentColor,
  hasSportsPartner,
}) => {
  const hasBundling = useIsInUltraModuleBundling()
  if (useClientViewportType() === 'desktop' || !children) {
    return null
  }
  if (!hasBundling) {
    return children
  }

  return (
    <StyledRelatedItemsWrapper
      accentColor={accentColor}
      hasSportsPartner={hasSportsPartner}
    >
      {children}
    </StyledRelatedItemsWrapper>
  )
}

export default RelatedItemsWrapper
